import DoctorAppointment from './DoctorAppointment';

export default DoctorAppointment;
